import {Filter} from "../models/Filter";
export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
 
export class AddFilterAction {
  readonly type = ADD_FILTER;
  constructor(public payload: Filter) { } 

} 

export class RemoveFilterAction {
  readonly type = REMOVE_FILTER;
  constructor(public payload: Filter) { } 
}

export type FilterAction = AddFilterAction | RemoveFilterAction;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/actions/filter.actions.ts